import React, { Children, cloneElement, forwardRef } from 'react';
import { Wrapper, Element } from './styled';
function getOrder(index, count) {
    if (index === 0)
        return 'first';
    if (index === count - 1)
        return 'last';
    return `${index}`;
}
const ButtonGroup = forwardRef(function ButtonGroup({ children, ...rest }, ref) {
    const count = Children.count(children);
    return (React.createElement(Wrapper, { ref: ref, ...rest }, Children.map(children, (btn, i) => {
        return (React.createElement(Element, null, cloneElement(btn, {
            groupPosition: getOrder(i, count)
        })));
    })));
});
export default ButtonGroup;
